import { Vector3 } from "three";
var start = new Vector3();
function anatomyToVector(item, out = new Vector3()) {
	if ("joints" in item) {
		start.fromArray(item.joints[0].pos);
		out.fromArray(item.joints[1].pos);
	} else {
		start.fromArray(item.points[0]);
		out.fromArray(item.points[1]);
	}
	return out.sub(start);
}
export { anatomyToVector };

//# sourceMappingURL=index6.js.map